import React, { useEffect, useState } from 'react';
import { Col, Row, Button, Container } from 'react-bootstrap';
import { IconButton } from '../../../../../components/buttons';
import { isPickedStatus } from '../../../../../services/helpers/status';
import WaybillOrder from "../../../../../components/templates/pdfs/waybillLabel";
import {PDFDownloadLink} from "@react-pdf/renderer";

const ActionSection = props => {
    let leftButton,middleButton,rightButton;
    const [ printReady, setPrintReady] = useState(false);

    if (!props.order.status || props.loading) {
        return null
    }

    if (props.order.status === 'placed') {
        rightButton = (
            <Col xs={3}>
                <IconButton 
                    onClick={() => props.onClickConfirm()}
                    loading={props.loading}
                    className="btn btn-sm btn-primary btn-block"
                    iconClassName="fas fa-truck"
                >
                    Konfirmasi
                </IconButton>
            </Col>
        )
    }

    if (!isPickedStatus(props.order.status)) {
        leftButton = (
            <Col xs={3}>
                <IconButton 
                    onClick={() => props.onClickCancel()}
                    loading={props.loading}
                    className="btn btn-sm btn-outline-primary btn-block"
                    iconClassName="fas fa-trash"
                >
                    Cancel
                </IconButton>
            </Col>
        )
    }

    if (props.order.courierWaybillId && props.order.courierWaybillId !== "-") {
        middleButton = (
            <Col xs={3}>
                {
                    printReady ? 
                        <PDFDownloadLink className="btn btn-sm btn-primary btn-block text-white" document={<WaybillOrder order={props.order}/>} fileName={`label-${Date.now()}.pdf`}>
                            {({ blob, url, loading, error }) => (loading ? 'Memuat label...' : 'Print Label')}
                        </PDFDownloadLink>
                        :
                        <Button className="btn btn-sm btn-outline-primary btn-block" onClick={() => setPrintReady(true)}>
                            Download Label
                        </Button>
                }
            </Col>
        )
    }

    if (leftButton == null && middleButton == null && rightButton == null) {
        return null
    }

    return (
        <Container>
            <Row className="border-top px-2 py-4 justify-content-end">
                { leftButton }
                { middleButton }
                { rightButton }
            </Row>
        </Container>
    )
}

export default ActionSection;